import { UserFilters } from 'app/pages/users/filters/UserListFilters';
import ConfigRoutes from 'app/routing/ConfigRoutes';
import { ContactService } from 'app/services/contacts/ContactService';
import moment from 'moment';
import { FC, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { TablesWidget9 } from '_metronic/partials/widgets/tables/TablesWidget9';


const ContactList: FC = () => {

    const [contacts, setContacts] = useState<Array<Object> | null>(null);
    const [pageCount, setPageCount] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchValue, setSearchValue] = useState<string>("");
    const [filters, setFilters] = useState<UserFilters | null>(null);

    const {id} = useParams();

    useEffect(() => {
        getContacts(currentPage, pageSize, undefined, searchValue);

    }, [currentPage, pageSize, filters, searchValue]);


    const getContacts = async (page?: number, limit?: number, orderFilters?: any, textSearch?: string) => {

        let params: any = {
            limit: limit == undefined ? pageSize : limit,
            page: page == undefined ? currentPage + 1 : page + 1,
            filter_filters: filters != null ? filters : {},
        }

        if (orderFilters != undefined) {
            params['filter_order'] = [orderFilters]
        }

        if (textSearch != undefined) {
            params.filter_filters['search'] = textSearch
        }

        let contacts = (await (new ContactService).getContactById(id as string, 'contacts', params)).getOnlyData();

        if (contacts.data != undefined && contacts.data.length > 0) {
            setContacts(contacts.data);
        } else {
            setContacts([]);
        }

        setPageCount(contacts.lastPage);
    }

    const handlePagination = async (pageObject: any) => {

        if (pageObject.selected < 0) {
            return;
        }

        setCurrentPage(pageObject.selected);
        await getContacts(pageObject.selected, pageSize);

    }

    const handlePerPage = async (pageSizeObject: any) => {
        setPageSize(pageSizeObject.value);
        setCurrentPage(0);
        await getContacts(0, pageSizeObject.value);
    }

    const handleSearch = (value: string) => {
        setSearchValue(value);
        getContacts(0, pageSize, undefined, value);
    }

    return (
        <div>
            {
                contacts === null ?
                    (
                        <div className="text-justify-content-md-center">
                            <span className='indicator-progress text-center' style={{ display: 'block' }}>
                                Please wait...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        </div>

                    )
                    :
                    (
                        <>
                            <TablesWidget9 className="card-primary" title="Users"
                            
                                searchInput={{ placeholder: "Search...", onSearch: handleSearch }}
                                data={contacts}
                                pagination={true}
                                paginationData={{
                                    pageSize: pageSize, pageCount: pageCount, currentPage: currentPage,
                                    handlePagination: handlePagination, handlePerPage: handlePerPage
                                }}
                                columns={[
                                    {
                                        name: "Created At", keyValue: 'creationDate', className: "min-w-100px", render: (element: any) => {
                                            let formatDate = moment(element.createdAt.date);
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-muted me-2 fs-7 fw-bold'>{formatDate.format('YYYY-MM-DD HH:mm')}</span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Updated At", keyValue: 'updateDate', className: "min-w-100px", render: (element: any) => {
                                            let formatDate = moment(element.updatedAt.date);
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-muted me-2 fs-7 fw-bold'>{formatDate.format('YYYY-MM-DD HH:mm')}</span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Validate", keyValue: 'validate', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.validate} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Zero Bounce", keyValue: 'zeroBounce', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.zeroBounce} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Active Campaign", keyValue: 'activeCampaign', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.activeCampaign} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Title", keyValue: 'title', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.title} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "First Name", keyValue: 'firstName', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.firstName} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Last Name", keyValue: 'lastName', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.lastName} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Email", keyValue: 'email', className: "min-w-100px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.email} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Email 2", keyValue: 'email2', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.email2} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "City", keyValue: 'city', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.city} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Country", keyValue: 'country', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.country} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Phone", keyValue: 'phone', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.phone} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Hospital", keyValue: 'hospital', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.hospital} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                    {
                                        name: "Department", keyValue: 'department', className: "min-w-120px", render: (element: any) => {
                                            return (
                                                <div className='d-flex flex-column w-100 me-2'>
                                                    <div className='d-flex flex-stack mb-2'>
                                                        <span className='text-bold me-2 fs-7 fw-bold'> {element.department} </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    },
                                ]}
                            ></TablesWidget9>
                        </>
                    )
            }
        </div>
    )
}

export { ContactList }




